import axios from "axios";
import { NOTIFICATIONS_MESSAGE_TYPES } from "../modules/Notifications/notificationsConstants";
import { sendNotificationMessageAction } from "../modules/Notifications/notificationsReducer";
import { LOG_EVENT_TYPES } from "./appConstants";

const axiosInstance = axios.create();

export const setupAxiosInterceptors = (axiosInstance, store) => {
    axiosInstance.interceptors.request.use(function (config) {
        if (store.getState().app.visibility) {
            config.headers['request-startTime'] = new Date().getTime().toString();
        }
        return config;
    });

    axiosInstance.interceptors.response.use(function (response) {
        try {
            const startTime = +response.config.headers['request-startTime'];
            if (startTime > 0 && store.getState().app.visibility) {
                const currentTime = new Date().getTime();
                const duration = currentTime - startTime;
                if (duration < 30000) {
                    store.dispatch(sendNotificationMessageAction({
                        type: NOTIFICATIONS_MESSAGE_TYPES.APP_LOG,
                        params: {
                            event: LOG_EVENT_TYPES.PING,
                            payload: {
                                duration,
                                method: response.config.method,
                                url: response.config.url,
                                // @ts-ignore
                                connection: (navigator.connection || navigator.mozConnection || navigator.webkitConnection),
                            }
                        }
                    }));
                }
            }
        } catch (e) {
            console.error(e);
        }
        return response;
    });
}

export default axiosInstance;
